<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style lang="scss">
@import "styles/common.scss";
* {
    margin: 0;
    padding: 0;
}

html, body {
    width: 100%;
    height: 100%;
    background: $body-color;
}

#app {
    width: 100%;
    height: 100%;

}
</style>



// WEBPACK FOOTER //
// src/App.vue